import { InjectionToken } from '@angular/core';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const GAMES_IMAGES_ASSETS_URL: InjectionToken<string> = new InjectionToken<string>('gamesImagesAssetsUrl');

// eslint-disable-next-line @typescript-eslint/naming-convention
export const SLIDE_TERMS_ENABLED: InjectionToken<boolean> = new InjectionToken<boolean>('slideTermsEnabled', {
  factory: () => true
});
